export const TYPES_WITH_LIMIT_PER_USER = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15, 17, 18, 22];

export const AUDIENCE_TO_COLUMN = {
  filiado: 'limitFiliado',
  amigo: 'limitAmigo',
  dependente: 'limitDependente',
};

export const isLimitByAudienceApplicable = (formValues, typeIdOverride) => {
  const raw = typeIdOverride ?? formValues?.type_id ?? formValues?.type_action;
  const typeId = parseInt(raw, 10);
  if (Number.isNaN(typeId)) return false;
  return TYPES_WITH_LIMIT_PER_USER.includes(typeId);
};

export const isLimitByAudienceFeatureEnabled = (auth) => {
  const station = auth?.user?.establishments?.[0]?.stations?.[0];
  return !!(station?.guest_feature_enabled && station?.limit_by_audience_enabled);
};
